import React from "react";
import PropTypes from "prop-types";
import ImageYoutubeLogo from "components/utility/images/ImageYoutubeLogo";
import ImageLinkedInLogo from "components/utility/images/ImageLinkedInLogo";

const HeaderSocialLink = (props) => {
	const { label, subLinks } = props.data;
	const theme = props.theme;

	const injectSvg = (sublink) => {
		const label = sublink.label;

		if (label === "YouTube") {
			return <ImageYoutubeLogo fillColor={theme.socialIconsColor} />;
		} else if (label === "LinkedIn") {
			return <ImageLinkedInLogo fillColor={theme.socialIconsColor} />;
		}
	};

	return subLinks && subLinks.length > 0 ? (
		<div className="follow-us-container follow-us-theme--white content-above">
			<p className="follow-us-message">{label}</p>
			<ul className="follow-us-list-row">
				{subLinks.map((subLink, index) => {
					return (
						<li key={index}>
							<a
								href={subLink.url}
								className="follow-us-link"
								title={subLink.label}
								target="_blank"
								rel="noopener noreferrer"
								key={index}
								data-a="true"
								data-a-lbl={subLink.label}
								data-a-cat="Navigation"
								data-a-act="Header"
							>
								{injectSvg(subLink)}
							</a>
						</li>
					);
				})}
				<li></li>
			</ul>
		</div>
	) : null;
};
HeaderSocialLink.propTypes = {
	data: PropTypes.shape({
		url: PropTypes.string,
		label: PropTypes.string,
		imageUrl: PropTypes.string,
		subLinks: PropTypes.array
	})
};

export default HeaderSocialLink;
